import { takeEvery, put, all } from 'redux-saga/effects'
import { normalize } from 'normalizr'
import { CREATE_NEW_SP } from 'actions/referenceParameter'
import {
  DUPLICATE_SUPPORT_PARAM,
  GET_SUPPORT_PARAMETER,
} from 'actions/supportParameter'
import {
  addToAsyncSet,
  removeFromAsyncSet,
  API_ERROR,
} from 'actions/application'
import {
  getDefaultSupportParameterUri,
  getSupportParameter,
  duplicateSupportParameter,
} from 'services/supportParameters.js'
import { supportParameterSchema } from 'schemas/supportParameter'

function* createNewSP(action) {
  const { spType } = action
  const signal = CREATE_NEW_SP
  yield put(addToAsyncSet({ signal }))

  try {
    const { data: uri } = yield getDefaultSupportParameterUri({ spType })
    const splitUri = uri.split('/')
    const supportParameterNumber = splitUri[splitUri.length - 1]

    const { data } = yield getSupportParameter({ supportParameterNumber })
    const normalizedDefaultSPResponse = normalize(data, supportParameterSchema)
    const { entities, result } = normalizedDefaultSPResponse
    const originalSupportParameter = entities.supportParameters[result]
    yield put({
      // we need to put the default param in the store for diffing the newly duplicated one
      type: GET_SUPPORT_PARAMETER,
      data: { ...normalizedDefaultSPResponse },
    })
    const response = yield duplicateSupportParameter({
      originalSupportParameter,
    })

    yield put({
      type: DUPLICATE_SUPPORT_PARAM,
      originalSupportParameter,
      data: normalize(response.data, supportParameterSchema),
    })
    yield put(removeFromAsyncSet({ signal }))
  } catch (err) {
    yield all([
      put({ type: API_ERROR, err, signal }),
      put(removeFromAsyncSet({ signal })),
    ])
  }
}

export default function* watchCreateNewSP() {
  yield takeEvery(CREATE_NEW_SP, createNewSP)
}
